(() => {
  'use strict';

  if (window.__dotdShareInitialized) {
    return;
  }

  window.__dotdShareInitialized = true;

  const setStatus = (status, message) => {
    if (!status) return;

    window.clearTimeout(status.dotdShareTimer);
    status.textContent = message || '';

    if (message) {
      status.dotdShareTimer = window.setTimeout(() => {
        status.textContent = '';
      }, 2000);
    }
  };

  const fallbackCopy = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    textarea.style.pointerEvents = 'none';

    document.body.appendChild(textarea);

    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);

    const copied = document.execCommand('copy');

    document.body.removeChild(textarea);

    if (!copied) {
      throw new Error('Copy command failed');
    }
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-dotd-share-copy]');
    if (!button) return;

    event.preventDefault();

    const shareRoot =
      button.closest('[data-dotd-share]') ||
      button.closest('.dotd-share');

    const status = shareRoot?.querySelector(
      '[data-dotd-share-status]',
    );

    const url =
      button.getAttribute('data-share-url') || '';

    if (!url) {
      setStatus(status, 'コピーできませんでした');
      return;
    }

    try {
      if (
        navigator.clipboard &&
        window.isSecureContext
      ) {
        await navigator.clipboard.writeText(url);
      } else {
        fallbackCopy(url);
      }

      setStatus(status, 'コピーしました');
    } catch (error) {
      try {
        fallbackCopy(url);
        setStatus(status, 'コピーしました');
      } catch (fallbackError) {
        setStatus(status, 'コピーできませんでした');
      }
    }
  });
})();